module.exports = __webpack_public_path__ + "static/media/nenglifen2.e25f723a.jpg";